import _each from 'lodash/each';

function Ctrl($rootScope, $scope, $state, $stateParams, $sce, $window, $http, bookingHelpers, bookingService,
  userService, paymentService, modalService, utilsService, loggerService, metaTagService, jsSdkBooking) {
  $scope.booking = null;
  $scope.status = {};
  $scope.tickets = [];
  $scope.errorMsg = null;
  $scope.facebookJoinMessageUrl = null;
  $scope.error = null;
  $scope.loading = true;

  const bookingId = $stateParams.booking;

  metaTagService.set({
    title: 'Your Booking Receipt',
    description: 'Your Booking Receipt',
    deeplink: `booking/${bookingId}`
  });

  $scope.shareBarConfig = {
    url: utilsService.createUrl('/'),
    message: 'I just booked on Tablelist!'
  };

  function initialize(bookingId2) {
    $scope.error = null;

    jsSdkBooking.read(bookingId2)
      .then(function(resp) {

        $scope.loading = false;

        if (!resp || !resp.id) {
          $scope.error = 'Unable to find booking.';
          return;
        }

        const booking = resp;

        $scope.booking = booking;
        $scope.error = null;

        updatePage(booking);

        $scope.status = bookingHelpers.getStatus(booking);

        if (bookingHelpers.hasTickets(booking)) {
          getTickets(booking.id);
        }

        let paymentProfileID;

        if (booking.payment === 'PAYMENT_PLAN') {
          paymentProfileID = booking.paymentPlan.paymentProfile;
        } else {
          paymentProfileID = currentUsersPaymentProfileID(booking);
        }

        _loadPaymentProfile(paymentProfileID);
      }, function error(resp) {
        $scope.loading = false;
        $scope.error = utilsService.errorMessage(resp);
      });
  }

  function updatePage(booking) {
    $scope.mapUrl = $sce.trustAsResourceUrl(utilsService.getMapUrl(booking.venue.location.address));
    $scope.directMapUrl = utilsService.getMapUrl(booking.venue.location.address, true);
    $scope.ticketPDF = bookingHelpers.downloadTicketLink(booking);
  }

  initialize($stateParams.booking);

  $scope.remove = function(user) {
    if (confirm('Are you sure you would like to remove ' + (user.id === $scope.currentUser.id ? 'yourself' : user.name) + ' from the table?')) { //eslint-disable-line
      bookingService.decline($scope.booking.id, user.id).$promise.then(function success() {
          if (user.id === $scope.currentUser.id) {
            $state.go('app.home');
          } else {
            $state.go($state.currentState, {
              reload: true
            });
          }
        },
        function error(response) {
          $scope.error = response.data;
        });
    }
  };

  bookingService.listBookingTickets({
      id: bookingId
    })
    .then(function(response) {
      $scope.tickets = response;
    }, function error(response) {
      $scope.errorMsg = utilsService.errorMessage(response);
    });

  function getTickets(bookingId2) {
    $http.get(`/booking/${bookingId2}/ticket`)
      .then(function(resp) {
        $scope.packageTickets = resp.data;
      }, function(resp) {
        loggerService.error(resp);
      });
  }

  function currentUsersPaymentProfileID(booking) {
    if (!$rootScope.currentUser) return null;

    let paymentProfileID = null;

    _each(booking.users, function(i) {
      if (i.user && i.user.id === $rootScope.currentUser.id) {

        paymentProfileID = i.paymentProfile;
      }
    });

    return paymentProfileID;
  }

  function _loadPaymentProfile(paymentProfileID) {
    if (!paymentProfileID) return;

    paymentService.read(paymentProfileID).$promise.then(function success(resp) {
      $scope.paymentProfile = resp;
    });
  }
}

Ctrl.$inject = [
  '$rootScope',
  '$scope',
  '$state',
  '$stateParams',
  '$sce',
  '$window',
  'tl.http',
  'bookingHelpersService',
  'tl.booking.service',
  'tl.user.service',
  'tl.payment.service',
  'modalService',
  'utilsService',
  'loggerService',
  'metaTagService',
  'jsSdk.booking'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/receipt/receiptCtrl.js